import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import clsx from "clsx";
import { SidebarItems } from "../../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import { Settings } from "@mui/icons-material";
import useMediaQuery from "../../../base/useMediaQuery";

const SideBar = ({ setNavBar, open }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isDeskTop = useMediaQuery("(min-width: 850px)");
  const [active, setActive] = useState(location.pathname);

  useEffect(() => {
    setActive(location.pathname);
    if (location.pathname === "/admin") setActive("/admin/actor");
  }, [location]);

  const onClickItem = (href) => {
    navigate(href, { replace: false });
  };

  const openSideBar = () => setNavBar(true);
  const closeSideBar = () => setNavBar(false);

  return (
    <div className="flex">
      <Box
        className={clsx(
          "w-[240px] h-full overflow-hidden flex flex-col justify-between bg-[#F6F6F7]",
          {
            "": isDeskTop,
            "absolute duration-400 origin-left z-[5]": !isDeskTop,
            "transition-[transform] scale-x-0": !open && !isDeskTop,
            "transition-[transform] scale-x-100": open && !isDeskTop,
          }
        )}
      >
        <ul className="pt-[50px] px-3">
          {SidebarItems.map((item, index) => (
            <li
              key={`li-${index}`}
              className={clsx("my-1 select-none border-l-[4px]", {
                "border-[#004EE4]": active === item.href,
                "border-[transparent]": active !== item.href,
              })}
            >
              <div
                onClick={onClickItem?.bind(this, item.href)}
                className={clsx(
                  "px-7 py-1 ml-2 hover:bg-[#EDEEEF] cursor-pointer",
                  {
                    "bg-[#EDEEEF]": active === item.href,
                  }
                )}
              >
                <a
                  className={clsx("text-[20px] font-['Poppins-Medium']", {
                    "text-[#004EE4]": active === item.href,
                    "text-[#202223]": active !== item.href,
                  })}
                >
                  {item.label}
                </a>
              </div>
            </li>
          ))}
        </ul>
        <div className="px-2 mb-5 hidden">
          <div className="hover:bg-[#EDEEEF] px-7 py-1 select-none text-[20px] font-['Poppins-Medium'] cursor-pointer text-[#202223] flex gap-1 items-center">
            <Settings className="text-[20px]" />
            Settings
          </div>
        </div>
      </Box>
      {isDeskTop && (
        <div style={{ left: 240 }} className={"app-sidebar-resizer"} />
      )}
      {!isDeskTop && open && (
        <div
          onClick={closeSideBar}
          className="z-[4] fixed top-0 bg-[#3b3b3b8f] h-screen w-full"
        />
      )}
    </div>
  );
};

export default React.memo(
  SideBar,
  (prevProps, nextProps) => prevProps.open === nextProps.open
);
